module.exports = __webpack_public_path__ + "img/location-icon.510c7563.svg";